import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'icon',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss'],
    standalone: false,
})
export class IconsComponent implements OnInit {
    @Input() iconName: string;
    @Input() tooltip: string;
    @Input() isClassFilled?: boolean;

    @Output() onTrigger = new EventEmitter();

    constructor() {}

    ngOnInit() {}
}
